<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="全部订单" name="9"></el-tab-pane>
			<el-tab-pane label="待付款" name="0"></el-tab-pane>
			<el-tab-pane label="待发货" name="1"></el-tab-pane>
			<el-tab-pane label="待收货" name="2"></el-tab-pane>
			<el-tab-pane label="待评价" name="3"></el-tab-pane>
		</el-tabs>
		<div class="orderlist">
			<div class="search wd-flex wd-row-between">
				<el-input placeholder="商品名称-订单编号-收货信息" v-model="con"></el-input>
				<el-button class="wd-m-l-10" @click="newfind">查询</el-button>
			</div>
			<div class="title wd-theme-back wd-flex wd-row-left">
				<div class="goods wd-row-grow">商品信息</div>
				<div class="price">单价</div>
				<div class="num">数量</div>
				<div class="amount">订单金额</div>
				<div class="state">订单状态</div>
			</div>
			<div  v-if="wddatalist[tabindex].detail!=''">
				<div class="detail wd-m-t-10 wd-m-b-20 wd-border-bottom" v-for="(item,index) in wddatalist[tabindex].detail" :key="index">
					<div class="info wd-flex wd-row-between wd-border wd-theme-back wd-p-l-10 wd-p-r-10 wd-h-40 wd-lh-40">
						<div>
							<span class="wd-theme-999">下单时间：</span>
							<span class="wd-theme-333">{{item.listdate}}</span>
							<span class="wd-m-l-10 wd-theme-999">订单编号：</span>
							<span class="wd-theme-333">{{item.listseqno}}</span>
							<span class="wd-theme-999 wd-m-l-30 wd-icon">&#xe6b9;</span>
							<span class="wd-theme-333 wd-m-l-10">{{item.branchname}}</span>
						</div>
						<div>
							<el-button type="primary" size="mini" v-if="item.orderstate==0" @click="pay(item.id,item.listseqno)">立即支付</el-button>
							<el-button type="primary" size="mini" v-if="item.orderstate==2" @click="wdopt('endpos',item.id)">确认收货</el-button>
							
						</div>
					</div>
					<div class="goodslist  wd-flex wd-row-left wd-theme-back-fff" v-for="(itemd, indexd) in item.posdetail" :key="indexd">
						<div class="goods wd-row-grow wd-flex wd-row-between wd-border wd-p-l-20 wd-p-r-20 wd-cursor" @click="gotogoodsdetail(itemd.goodsid,itemd.name)">
							<div class="goodsimg"><el-image :src="$wdpicurl(itemd.pic1)" class="img"></el-image></div>
							<div class="name wd-row-grow">
								<span>{{ itemd.name }}</span>
								<span class="wd-m-l-5 wd-theme-999">{{itemd.prodate}}</span>
							</div>
						</div>
						<div class="price wd-border "><div class="wd-m-t-20"> ¥{{itemd.price1| amountFormatter}}</div></div>
						<div class="num wd-border"><div class="wd-m-t-20">{{itemd.num|numberFormatter}}</div></div>
						<div class="amount wd-border-right"><div class="wd-m-t-20"><span v-show="indexd===0">¥{{item.allamount| amountFormatter}}</span></div></div>
						<div class="state ">
							<div class="wd-m-t-20">
								<p v-show="indexd===0">
									<span class="wd-theme wd-font-bold" v-if="item.pintuanstate==2">{{item.orderstatetext}}</span>
									<span class="wd-theme wd-font-bold" v-else>{{item.teamstate}}</span>
									
								</p>
								<p v-show="indexd===0"><el-link type="info"><router-link tag="span" :to="{name:'Orderdetail',query:{posid:item.id,orderno:item.listseqno}}">订单详情</router-link></el-link> </p>
							</div>
						</div>
					</div>
				</div>
				<div class="wd-fr">
					<el-pagination
						:total="cnt"
						:background="true"
						layout="prev, pager, next"
						@size-change="pagesizechange"
						@current-change="currentchange"
						@prev-click="prevclick"
						@next-click="nextclick"
					></el-pagination>
				</div>
			</div>
			<div class="detail nodata" v-else>
				您还没有订单，快去<router-link :to="{path:'/'}" >逛逛吧</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Orderlist',
	data() {
		return {
			activeName: '9',
			con:'',
			reason:'',
			selectposid:'',
			selectreasondatalist:[
				"收货人信息有误",
				"商品数量或款式需要调整",
				"有更优惠的购买方案",
				"银行卡支付超限",
				"已付款，状态没有变",
				"我不想买了",
				"其他原因"
			],
			orderstate:9,
			cnt:-1,
			page:0,
			tabindex:0,
			wddatalist:[
				{id:9,cnt:-1,page:0,detail:[]},
				{id:0,cnt:-1,page:0,detail:[]},
				{id:1,cnt:-1,page:0,detail:[]},
				{id:2,cnt:-1,page:0,detail:[]},
				{id:3,cnt:-1,page:0,detail:[]}
			]
		};
	},
	methods: {
		wdopt(type,posid){
			let fun="";
			if (type=="canclepos"){
				fun="canclepos";
				if (this.reason==""){
					this.$wd_toast("请选择取消订单原因","error");
					return;
				}
				let indata={
					posid:posid,
					reason:this.reason
				}
				this.$wd_request(fun, indata)
				.then(data=>{
					this.$wd_toast(data.msg);
					this.cnt=-1;
					this.wddatalist[this.tabindex].detail=[];
					this.find();
				})
				.catch(()=>{})
			}else if (type=="endpos"){
				//确认收货
				fun="endpos";
				let indata={
					posid:posid,
				}
				this.$wd_request(fun, indata)
				.then(data=>{
					this.$wd_toast(data.msg);
					this.cnt=-1;
					this.wddatalist[this.tabindex].detail=[];
					this.find();
				})
				.catch(()=>{})
			}
		},
		pagesizechange(e) {
			this.page=e-1;
			this.find();
		},
		currentchange(e) {
			this.page=e-1;
			this.find();
		},
		prevclick(e) {
			this.page=e-1;
			this.find();
		},
		nextclick(e) {
			this.page=e-1;
			this.find();
		},
		pay(id,listseqno){
			this.$router.push({name:"Pay",query:{posid:id,orderno:listseqno}});
		},
		handleClick(e) {
			if (this.orderstate===this.activeName){
				return;
			}
			this.orderstate=e.name;
			this.tabindex=e.index;
			this.cnt=this.wddatalist[this.tabindex].cnt;
			this.page=this.wddatalist[this.tabindex].page;
			if (this.cnt===-1){
				this.find();
			}
		},
		newfind(){
			this.wddatalist[this.tabindex].cnt=-1;
			this.cnt=-1;
			this.find();
		},
		find(){
			if (this.cnt==-1){
				this.page=1;
			}else{
				if (this.page*this.$wd_limit>=this.cnt){
					return;
				}else
					this.page++;
			}
			this.wddatalist[this.tabindex].page=this.page;
			let indata={
				con:this.con,
				page:this.page,
				cnt:this.cnt,
				state:this.orderstate,
			}
			this.$wd_request("poslist",indata,true,".memdetail")
			.then(data=>{
				if (this.page===1){
					this.cnt=data.cnt;
				}
				// var item=this.wddatalist[this.tabindex];
				// item.detail=data.value;
				// this.$set(this.wddatalist,this.tabindex,item);
				this.wddatalist[this.tabindex].detail=data.value;
				this.$forceUpdate();
			})
			.catch(()=>{
				console.log("nodata");
			})
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname
				}
			});
		}
	},
	created() {
		this.find();
	}
};
</script>

<style lang="scss" scoped>
.orderlist {
	background-color: #ffffff;
	.search {
		width: 350px;
	}
	.title {
		height: 40px;
		margin-top: 20px;
		color: #333333;
		text-align: center;
	}
	.goods {
		.goodsimg {
			width: 60px;
			height: 60px;
			margin-right: 10px;
			.img {
				width: 60px;
				height: 60px;
			}
		}
	}
	.price {
		width: 150px;
		flex-shrink: 0;
		text-align: center;
	}
	.num {
		width: 150px;
		flex-shrink: 0;
		text-align: center;
	}
	.amount {
		width: 150px;
		flex-shrink: 0;
		text-align: center;
	}
	.state {
		width: 150px;
		flex-shrink: 0;
		text-align: center;
	}
	.other {
		width: 150px;
		flex-shrink: 0;
		text-align: center;
	}
	.detail {
		&.nodata{
			margin: 50px;
			text-align: center;
		}
		.goods {
			height: 80px;
			.goodsimg {
				width: 60px;
				height: 60px;
				margin-right: 10px;
				.img {
					width: 60px;
					height: 60px;
				}
			}
		}
		.price {
			width: 150px;
			flex-shrink: 0;
			text-align: center;
			height: 80px;
		}
		.num {
			width: 150px;
			flex-shrink: 0;
			text-align: center;
			height: 80px;
		}
		.amount {
			width: 150px;
			flex-shrink: 0;
			text-align: center;
			height: 80px;
		}
		.state {
			width: 150px;
			flex-shrink: 0;
			text-align: center;
			height: 80px;
		}
		.other {
			width: 150px;
			flex-shrink: 0;
			text-align: center;
			height: 80px;
		}
	}
}
</style>
